"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component, createRef } from "react";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { TabsContext } from "./Tabs";
var TabPanel = /*#__PURE__*/function (_Component) {
  _inherits(TabPanel, _Component);
  var _super = _createSuper(TabPanel);
  function TabPanel() {
    var _this;
    _classCallCheck(this, TabPanel);
    _this = _super.apply(this, arguments);
    _this.panelRef = createRef();
    _this.handleResize = function (width, height) {
      _this.context.updatePanelHeight(height);
    };
    return _this;
  }
  _createClass(TabPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.setPanelRef(this.panelRef);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        index = _this$props.index,
        status = _this$props.status,
        className = _this$props.className,
        direction = _this$props.direction;
      var id = this.context.id;
      return /* @__PURE__ */React.createElement("div", {
        className: classNames("tabs__tab-panel", "tabs__tab-panel--".concat(status), className, _defineProperty({}, "tabs__tab-panel--".concat(direction === 1 ? "next" : "previous"), !["entered", "entering"].includes(status != null ? status : ""))),
        role: "tabpanel",
        id: "tabs-".concat(id, "-panel-").concat(index),
        "aria-labelledby": "tabs-".concat(id, "-tab-").concat(index),
        ref: this.panelRef,
        tabIndex: -1
      }, /* @__PURE__ */React.createElement(ReactResizeDetector, {
        handleHeight: true,
        onResize: this.handleResize
      }), children);
    }
  }]);
  return TabPanel;
}(Component);
TabPanel.contextType = TabsContext;
export default TabPanel;